import {CPSConstants} from "commonUtils/enumerations";

export const singleSelectDropdownStyles = {
  dropdown: {
    fontFamily: CPSConstants.FONT_FAMILY,
    marginTop: "1rem",
    width: "15rem",
    minWidth: "10rem",
    "& .MuiSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY,
      padding: "8px 8px",
    },
  },
  muilabel: {
    fontFamily: CPSConstants.FONT_FAMILY,
    color: "black",
  },
};
